<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid text-start">
        <p class="fs-6 m-2">
          {{ this.$route.meta.title }}
          {{ userFullName ? "برای " + userFullName : "" }}
          شماره فاکتور:
          {{ orderId ? orderId : "ایجاد نشده است" }}
        </p>
        <div v-if="error" class="alert alert-danger">
          {{ error }}
        </div>

        <div class="m-2 row bg-light py-2">
          <div v-if="!this.$route.params.userId" class="col-12 col-sm-4 mt-1">
            <label for="users_select">جستجوی کاربر</label>
            <multiselect
              v-model="userId"
              id="users_select"
              placeholder="شروع به نوشتن کنید"
              open-direction="bottom"
              :options="users"
              :searchable="true"
              :loading="isLoading"
              :options-limit="300"
              :max-height="600"
              :hide-selected="true"
              @search-change="getUsers"
            >
            </multiselect>
          </div>
          <div class="col-12 col-sm-4">
            <label>انتخاب محصول</label>
            <Multiselect
              class="my-1"
              v-model="productId"
              mode="single"
              :searchable="true"
              :createTag="true"
              :options="productOptions"
            />
          </div>
          <div class="col-12 col-sm-4" v-if="sesssionsList">
            <label>انتخاب جلسه</label>
            <Multiselect
              class="my-1"
              v-model="sessionId"
              mode="single"
              :searchable="true"
              :createTag="true"
              :options="sesssionsList"
            />
          </div>

          <div class="col-12 col-sm-4" v-else-if="productTypeIsPackage">
            <label>انتخاب دروس</label>
            <Packages
              :productId="productId"
              :key="productId"
              @setProductChildIds="setProductChildIds"
            />
          </div>

          <div class="col-12">
            <button
              v-if="sessionId"
              class="btn btn-primary"
              @click="addVideoSessionToOrder"
            >
              افزودن به فاکتور.
            </button>

            <button
              v-else-if="productTypeIsPackage"
              class="btn btn-primary"
              @click="addPackageToOrder"
            >
              افزودن پکیج به فاکتور
            </button>

            <button v-else class="btn btn-primary" @click="addProductToOrder">
              افزودن به فاکتور
            </button>

            <span v-show="showSpin">
              <i class="fas fa-spinner fa-spin mt-3"></i>
            </span>
          </div>
        </div>
        <div v-if="cart">
          <table
            class="
              table table-responsive table-striped table-hover
              align-middle
            "
          >
            <thead>
              <tr>
                <th style="width: 40px">#</th>
                <th>محصول</th>
                <th>کد</th>
                <th>تعداد</th>
                <th>قیمت واحد</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in cart.orderDetail" :key="item.id">
                <template v-if="item.all_videos_buy">
                  <tr>
                    <td>
                      <a
                        class="border border-secondary btn btn-close btn-sm"
                        @click="deleteProduct(item.id)"
                      ></a>
                    </td>
                    <td>
                      <img
                        style="width: 50px"
                        :src="
                          API_STORAGE_URL + item.product.main_image_thumb_path
                        "
                        @error="noPic"
                      />
                      {{ item.product.name }} - دوره کامل
                    </td>
                    <td>
                      {{ item.product.id }}
                    </td>
                    <td>
                      {{ item.number }}
                    </td>
                    <td>
                      {{ this.utils.monize(item.price) }}
                      تومان
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <template
                    v-for="itemDetails in item.productDetails"
                    :key="itemDetails.productDetailVideo.id"
                  >
                    <tr>
                      <td>
                        <a
                          class="border border-secondary btn btn-close btn-sm"
                          @click="
                            deleteMicroProduct(
                              item.id,
                              itemDetails.productDetailVideo.id
                            )
                          "
                        ></a>
                      </td>
                      <td>
                        <img
                          style="width: 50px"
                          :src="
                            API_STORAGE_URL + item.product.main_image_thumb_path
                          "
                        />
                        جلسه
                        {{ itemDetails.numName }}
                        -
                        {{ item.product.name }}
                      </td>
                      <td>
                        {{ itemDetails.productDetailVideo.id }}
                      </td>
                      <td>1</td>
                      <td>
                        {{ this.utils.monize(itemDetails.price) }}
                        تومان
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
            </tbody>
          </table>
          <div class="d-flex">
            <a class="border btn btn-sm text-secondary" @click="emptyOrder">
              <i class="far fa-times-circle"></i>
              حذف تمامی موارد و خالی کردن سبد خرید
            </a>
          </div>
          <div class="row">
            <div class="col"></div>
            <div class="col">
              <p class="fs-4">صورت حساب</p>

              <div>
                <table class="table table-responsive">
                  <tbody>
                    <tr>
                      <td>مجموع قیمت های محاسبه شده:</td>
                      <td dir="ltr">
                        {{ this.utils.monize(totalPrice) }}
                        تومان
                      </td>
                    </tr>
                    <tr>
                      <td>پرداختی کاربر:</td>
                      <td dir="ltr">
                        <input
                          class="form-control"
                          v-model="amount"
                          type="number"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>توضیحات:</td>
                      <td>
                        <textarea
                          class="form-control"
                          v-model="description"
                        ></textarea>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col">
                <div
                  class="
                    alert alert-card alert-success
                    d-flex
                    justify-content-around
                    fs-4
                  "
                  role="alert"
                >
                  <div>
                    <a class="btn btn-success" @click="completeBuying()"
                      >تایید نهایی فاکتور</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheSidemenu from "../../components/TheSidemenu";
import TheTopmenu from "../../components/TheTopmenu";
import ArefApi from "../../libs/api.js";
import Multiselect from "@vueform/multiselect";
import utils from "../../libs/utils.js";
import Packages from "./components/Packages.vue";

export default {
  name: "AddOrder",
  created() {
    this.arefApi = new ArefApi();
    this.utils = new utils();
    this.API_STORAGE_URL = process.env.VUE_APP_API_STORAGE_URL;
    this.addNewOrder();
    this.getProductsList();
  },
  components: {
    TheSidemenu,
    TheTopmenu,
    Multiselect,
    Packages,
  },
  data() {
    return {
      error: null,
      showSpin: false,
      productsList: null,
      productOptions: null,
      productId: null,
      sesssionsList: null,
      sessionId: null,
      orderId: null,
      cart: null,
      userId: this.$route.params.userId ? this.$route.params.userId : null,
      userFullName: this.$route.params.userFullName
        ? this.$route.params.userFullName
        : null,
      amount: null,
      description: null,
      mobile: null,
      users: [],
      isLoading: false,
      productTypeIsPackage: false,
      childProducts: null,
      productChildIds: [],
    };
  },
  methods: {
    getProductsList() {
      this.arefApi.getProductsIndex(1, true).then((res) => {
        this.productsList = res.data;
        this.productOptions = this.productsList.map((item) => {
          return { value: item.id, label: item.name };
        });
      });
    },
    getProductVideoSessions() {
      this.arefApi
        .getProductVideoSessions(this.productId, 1, true)
        .then((sesssionsList) => {
          this.sesssionsList = sesssionsList.data.map((item) => {
            return { value: item.id, label: item.name };
          });
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    addNewOrder() {
      return new Promise((resolve, reject) => {
        if (!this.userId) {
          return resolve();
        }
        const userData = {
          users_id: this.userId,
        };
        this.arefApi
          .addNewOrder(userData)
          .then((resp) => {
            this.orderId = resp.data.id;
            this.cart = resp.data;
            resolve();
          })
          .catch((err) => {
            this.utils.showErrors(this, err);
            reject();
          });
      });
    },
    async addProductToOrder() {
      if (!(await this.createOrderCheck())) {
        return;
      }
      const productData = {
        products_id: this.productId,
        number: 1,
      };
      this.arefApi
        .addProductToOrder(this.orderId, productData)
        .then((resp) => {
          this.utils.showSuccess(this);
          this.cart = resp.data;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    async addVideoSessionToOrder() {
      if (!(await this.createOrderCheck())) {
        return;
      }
      const productData = {
        products_id: this.productId,
        product_details_id: this.sessionId,
      };
      this.arefApi
        .addVideoSessionToOrder(this.orderId, productData)
        .then((resp) => {
          this.utils.showSuccess(this);
          this.cart = resp.data;
        })
        .catch((err) => {
          console.log(err);
          this.utils.showErrors(this, err);
        });
    },
    async addPackageToOrder() {
      await this.validateChildItems();
      if (!(await this.createOrderCheck())) {
        return;
      }
      const packageData = {
        product_id: this.productId,
        child_product_ids: this.productChildIds,
        user_id: this.userId,
      };
      this.arefApi
        .addPackageToOrder(packageData)
        .then((resp) => {
          this.utils.showSuccess(this);
          this.cart = resp.data;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    deleteProduct(order_details_id) {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .deleteProductFromOrder(this.orderId, order_details_id)
              .then((resp) => {
                this.cart = resp.data;
                if (
                  resp.data.length == 0 ||
                  resp.data.orderDetail.length == 0
                ) {
                  this.cart = null;
                  this.showSpin = false;
                }
                this.utils.showSuccess(this);
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
    deleteMicroProduct(order_details_id, product_detals_id) {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .deleteMicroProductFromOrder(
                this.orderId,
                order_details_id,
                product_detals_id
              )
              .then((resp) => {
                this.cart = resp.data;
                if (
                  resp.data.length == 0 ||
                  resp.data.orderDetail.length == 0
                ) {
                  this.cart = null;
                  this.showSpin = false;
                }
                this.utils.showSuccess(this);
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
    emptyOrder() {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .emptyOrder(this.orderId)
              .then(() => {
                this.cart = null;
                this.showSpin = false;
                this.utils.showSuccess(this);
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
    completeBuying() {
      if (!this.cart || this.cart.orderDetail.length == 0) {
        this.$swal.fire({
          title: "!خطا",
          text: `هیچ آیتمی در فاکتور وجود ندارد`,
          icon: "error",
          confirmButtonText: "متوجه شدم",
        });
        return;
      }
      if (!this.amount) {
        this.$swal.fire({
          title: "!خطا",
          text: `پرداختی کاربر را وارد نمایید`,
          icon: "error",
          confirmButtonText: "متوجه شدم",
        });
        return;
      }
      if (!this.description) {
        this.$swal.fire({
          title: "!خطا",
          text: `توضیحات را وارد نمایید`,
          icon: "error",
          confirmButtonText: "متوجه شدم",
        });
        return;
      }
      this.$swal
        .fire({
          title: "پرداخت",
          text: "آیا از تایید فاکتور اطمینان دارید؟",
          icon: "success",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله",
        })
        .then((value) => {
          if (value.isConfirmed) {
            const orderData = {
              amount: this.amount,
              description: this.description,
            };
            this.arefApi
              .completeOrder(this.orderId, orderData)
              .then(() => {
                this.utils.showSuccess(this);
                this.$router.push({ name: "AdminHome" });
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
    getUsers(query) {
      if (query.length <= 2) {
        return;
      }
      this.isLoading = true;
      const formSearch = {
        name: query,
        email: null,
        per_page: "all",
      };
      this.users = [];
      this.arefApi
        .searchUser(formSearch)
        .then((resp) => {
          this.users = resp.data.map((item) => {
            return {
              value: item.id,
              label: `${item.first_name} ${item.last_name} ${item.email}`,
            };
          });
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    // searchUser() {
    //   if (this.mobile.length != 11) {
    //     return;
    //   }
    //   const searchData = {
    //     per_page: "all",
    //     email: this.mobile,
    //   };
    //   this.arefApi
    //     .searchUser(searchData)
    //     .then((resp) => {
    //       if (resp.data.length == 1) {
    //         this.userId = resp.data[0].id;
    //         this.userFullName =
    //           resp.data[0].first_name + " " + resp.data[0].first_name;
    //       }
    //     })
    //     .catch((err) => {
    //       this.utils.showErrors(this, err);
    //     });
    // },
    async createOrderCheck() {
      let out = false;
      if (!this.userId) {
        if (!this.orderId) {
          this.$swal.fire({
            title: "!خطا",
            text: `کاربر انتخاب نشده است`,
            icon: "error",
            confirmButtonText: "متوجه شدم",
          });
          return out;
        }
      }
      if (!this.orderId) {
        await this.addNewOrder();
        if (!this.orderId) {
          this.$swal.fire({
            title: "!خطا",
            text: `خطا در ایجاد فاکتور`,
            icon: "error",
            confirmButtonText: "متوجه شدم",
          });
          return out;
        }
      }
      return true;
    },
    noPic(e) {
      e.target.src =
        process.env.VUE_APP_API_STORAGE_URL + process.env.VUE_APP_NO_IMAGE_URL;
    },
    getAdminChildProducts() {
      this.arefApi
        .getAdminChildProducts(this.productId)
        .then((resp) => {
          this.childProducts = resp.data;
          this.productChildIds = this.childProducts.others.map((x) => x.id);
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    setProductChildIds(productChildIds) {
      this.productChildIds = productChildIds;
    },
    validateChildItems() {
      let selectedProductChildIds = Object.values(this.productChildIds);
      if (
        selectedProductChildIds.length === 0 &&
        this.canSecelectProducts.length > 0
      ) {
        this.$swal.fire({
          title: "!خطا",
          text: "لطفا یکی از اساتید لیست را انتخاب فرمایید",
          icon: "error",
          confirmButtonText: "متوجه شدم",
        });

        return Promise.reject();
      }
      let isExist = false;
      let errorLabel = "";
      for (const i in this.canSecelectProducts) {
        isExist = false;
        errorLabel = i;
        for (const j in this.canSecelectProducts[i]) {
          if (
            selectedProductChildIds.indexOf(this.canSecelectProducts[i][j].id) >
            -1
          ) {
            isExist = true;
          }
        }
        if (!isExist) {
          document.getElementById("selectTeacherDiv").scrollIntoView();
          this.$swal
            .fire({
              title: "!خطا",
              text: `لطفا از آیتم ${errorLabel} یک مورد را علامت بزنید`,
              icon: "error",
              confirmButtonText: "متوجه شدم",
            })
            .then(() => {
              setTimeout(() => {
                document
                  .getElementById("selectTeacherDiv")
                  .scrollIntoView(true);
              }, 1000);
            });

          return Promise.reject();
        }
      }
      return Promise.resolve();
    },
  },
  computed: {
    totalPrice: function () {
      if (!this.cart || !this.cart.orderDetail) {
        return 0;
      }
      return this.cart.orderDetail.reduce(function (totalPrice, item) {
        return totalPrice + item.total_price;
      }, 0);
    },
    canSecelectProducts() {
      let out = { ...this.childProducts };
      delete out.others;
      return out;
    },
  },
  watch: {
    productId: function (newVal) {
      this.sesssionsList = null;
      this.sessionId = null;
      this.productTypeIsPackage = false;
      if (!newVal) {
        return;
      }
      const foundProduct = this.productsList.find((item) => item.id == newVal);
      if (foundProduct.type == "video") {
        this.getProductVideoSessions();
      }
      if (foundProduct.type == "package") {
        this.productTypeIsPackage = true;
        this.getAdminChildProducts();
      }
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>